export default __webpack_public_path__ + "static/media/icon-profile.339e80d5.svg";